$(document).ready(function () {


    if ($("img.LookBookItemImage").length > 0) {

        $("img.LookBookItemImage").rwdImageMaps();

        $('map area[data-curname!=""]').qtip({ // Grab all elements with a non-blank data-tooltip attr.
            //content: {
            //    attr: 'href' // Tell qTip2 to look inside this attr for its content
            //},
            //content: {
            //    text: 'I really like owls!',
            //    title: 'About me'
            //},
            style: {
                classes: 'blue qtip-blue qtip-shadow'
            },
            content: {
                text: function (event, api) {
                    // Retrieve content from ALT attribute of the $('.selector') element
                    return $(this).data('curname');
                },
                title: function (event, api) {
                    // Retrieve content from ALT attribute of the $('.selector') element
                    return $(this).data('curprice');
                }
            },
            position: {
                target: 'mouse',
                adjust: {
                    x: 20,
                    y: 10// Can be omitted (e.g. default behaviour)
                }
            }
        });


        $("map area").live({
            mouseenter:
               function (event) {

                   var map = $(this).closest("map").attr("id").replace("#", "");

                   $img = $("img[usemap$='" + map + "']");

                   $Areacon = $("img[usemap$='" + map + "']").closest(".LookBookItemArea");

                   //$curNameAndPrice = $Areacon.find(".CurrentNameAndPrice");

                   //$curNameAndPrice.find(".CurName").html($(this).data("curname"));
                   //$curNameAndPrice.find(".CurPrice").html($(this).data("curprice"));

                   //$curNameAndPrice.stop().fadeIn();

                   // $Areacon.find(".CurrentNameAndPrice").stop().fadeIn();
 
                   //var x = event.offsetX === undefined ? event.originalEvent.layerX : event.offsetX;
                   //var y = event.offsetY === undefined ? event.originalEvent.layerY : event.offsetY;
                    

               },
            mouseleave:
               function (event) {

                   var map = $(this).closest("map").attr("id").replace("#", "");

                   $Areacon = $("img[usemap$='" + map + "']").closest(".LookBookItemArea");


                   //$curNameAndPrice = $Areacon.find(".CurrentNameAndPrice");
                   //$curNameAndPrice.stop().fadeOut();

                   //$curNameAndPrice.find(".CurName").html("");
                   //$curNameAndPrice.find(".CurPrice").html("");
                    
               }


        });


        $(".LookBookItemAreaContainer map area").live("click", function (e) {

            var href = $(this).attr("href");
            var ProductID = $(this).data("productid");
            var ColorID = $(this).data("colorid");

            if (ColorID == undefined || ColorID == "") {
                ColorID = 0;
            }

            if (ProductID == undefined || ProductID == "") {
                ProductID = 0;
            }

            if (ProductID == 0 || ColorID == 0 && href != undefined && href.length > 0) {
                //document.location = href;
                //return;
                // e.preventDefault();
            }
            else {

                $Modal = $("div#QuickLookModal");
                $.ajax({
                    type: 'get',
                    url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/QuickLook",
                    data: 'ProductID=' + ProductID + "&ColorID=" + ColorID,
                    success: function (dt) {

                        $("div#QuickLookModal .modal-body").html(dt);

                        // var parentURL = $(this).closest(".Prd").find("a:first").attr("href");

                        $(".ProductDetail .Colors a[data-id='" + ColorID + "']").trigger("click");
                        //$(this).closest(".Prd").find("a:first, a.GotoDetails").attr("href", parentURL.split("#")[0] + "#C=" + $(this).attr("data-color"));



                    }
                });


                $Modal.modal("show");
                return false;
                e.preventDefault;

            }


        });


        $("#QuickLookModal .ProductSuggestHeader").live("click", function (e) {

            $("#QuickLookModal .Productsuggest").toggle();
            $("#QuickLookModal .CombineInfoPd").toggle();

        });

    }



});